import React from 'react';
import CompanyFooter from './CompanyFooter';
import {Typography} from 'antd';
// @ts-ignore
import pkg from '../../package.json';

const {Text} = Typography;

export const ReportFooter: React.FC = () => {
  return (
    <>
      <CompanyFooter />
      <Text className="footer-meta">
        {pkg.name} V – {pkg.version}
      </Text>
    </>
  );
};
